import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { components } from '../../schema/backend';
import { FileSystemService } from '../file-system.service';
import { SDTMWorkflow } from '../workflow.service';
import { lastValueFrom } from 'rxjs';
import { Message } from '../../components/chat/chat.component';
import { environment } from '../../../environments/environment';
import { AiResponse } from '../../schema/frontendTypes';
import { UserSettingsService } from '../user-settings.service';
import { WorkflowUpdate } from '../workflow.service';

// const SPEC_FILE_PATH = '/workspace/spec.yaml';
// const CODELIST_PATH = '/workspace/ct-table.csv';
// const finalScriptPath = (domain: string) => `/workspace/scripts/sdtm/${domain}.R`;
// const SCRATCHPAD_PATH = '/workspace/scratchpad/';


// type SdtmNextRequest = paths['/sdtm/next']['post']['requestBody']['content']['application/json'];
// type SdtmNextResponse = paths['/sdtm/next']['post']['responses']['200']['content']['application/json'];
// type State = components['schemas']['SdtmWorkflowRequest']['current_state'];
// type State = string;
// type ChatRequest = components['schemas']['ChatRequest'];
// type History = components['schemas']['ChatRequest']['history'];
// type ResponseFiles = components["schemas"][""][] | null;

// new types
type SdtmWorkflowState = components['schemas']['SdtmWorkflowState'];

export type SDTMActionResult = {
  type: 'answer' | 'query' | null;
  content: string;
};

@Injectable({
  providedIn: 'root',
})
export class SdtmService {
  constructor(private http: HttpClient, private fs: FileSystemService, private user: UserSettingsService) { }
  remainingDomains: [string, string][] = [];
  appState: SdtmWorkflowState | null = null;
  currentHistory: Message[] = [];
  workflowUpdate = signal<WorkflowUpdate | null>(null);

  async handleAiAnswer(aiAnswer: AiResponse, workflow: SDTMWorkflow): Promise<{ nextPrompt: string | null, setNewContext: boolean }> {
    let nextPrompt: string | null = null;
    let setNewContext: boolean = false;

    if (this.remainingDomains.length === 0) {
      this.remainingDomains = Object.keys(workflow.data.selections).map((category) => {
        const domain = workflow.data.selections[category].domain;
        return [category, domain];
      });
    }
    if (!this.appState) {
      this.appState = {
        selections: workflow.data.selections[this.remainingDomains[0][0]],
        spec_info: workflow.data.specInfo || localStorage.getItem('selectedNodes') || '',
        spec: {},
        codelist_df: null,
        current_state: 'start',
        recent_ai_answer: null,
        next_state_prompt: null,
        error: null,
      };
    }
    this.appState.recent_ai_answer = aiAnswer.content;
    const newState: SdtmWorkflowState = await lastValueFrom(
      this.http.post<SdtmWorkflowState>(environment.backendUrl + '/sdtm/next-v2', { ...this.appState })
    );
    if (newState.error) {
      nextPrompt = newState.error;
      return { nextPrompt, setNewContext: false };
    }
    if (!newState.next_state_prompt && newState.current_state !== 'done') {
      throw new Error('No next state prompt found in SDTM workflow state', { cause: { code: "CRITICAL_PROMPT_NOT_FOUND" } });
    }
    if (newState.current_state !== this.appState.current_state) {
      if (newState.current_state.split("/")[0] !== this.appState.current_state.split("/")[0]) {
        setNewContext = true;
      }
      this.appState = newState;
    }
    nextPrompt = newState.next_state_prompt as string;
    if (this.appState.current_state === 'done') {
      nextPrompt = null;
    }
    if (newState.current_state === 'script') {
      await this.fs.uploadFiles([new File([JSON.stringify(this.appState.spec, null, 2)], `spec.json`, { type: "application/json" })], this.fs.rootNode);
      await this.fs.uploadFiles([new File([this.appState.codelist_df!], `codelist.csv`, { type: "text/csv" })], this.fs.rootNode);
      this.fs.refreshRootNode();
    }
    return { nextPrompt, setNewContext };
  }

  //   private parseSDTMResponse(response: string | null): SDTMActionResult {
  //   let astRespType: 'answer' | 'query' | null = null;
  //   let astContent: string | null = null;

  //   if (typeof response === 'string') {
  //     const tagMatch = response.match(/<(provideAnswer|requireClarification)>([\s\S]*)<\/\1>/i);
  //     if (tagMatch) {
  //       astRespType = tagMatch[1] === 'provideAnswer' ? 'answer' : 'query';
  //       astContent = tagMatch[2].trim();
  //     }
  //   }

  //   return {
  //     type: astRespType,
  //     content: astContent || 'Could not get result'
  //   };
  // }

  // async uploadResponseFiles(files: ResponseFiles): Promise<void> {
  //   for (const file of files!) {
  //     const newNode = this.fs.rootNode.insert(file.path, false, file.content);
  //     const fileName = file.path.split('/').filter(Boolean).pop();
  //     if (!fileName) {
  //       throw new Error('File name could not be determined from path: ' + file.path);
  //     }
  //     await this.fs.uploadFiles([new File([file.content], fileName, { type: "text/plain" })], newNode.parentNode!);
  //   }
  //   await this.fs.refreshRootNode();
  // }

  async skipCurrentState() {
    return { nextPrompt: null, setNewContext: true }
  }

  cleanup() {
    this.appState = null;
    this.workflowUpdate.set(null);
  }
}
